import { render, staticRenderFns } from "./PaintedRock.vue?vue&type=template&id=39ddeac3&scoped=true&"
import script from "./PaintedRock.vue?vue&type=script&lang=js&"
export * from "./PaintedRock.vue?vue&type=script&lang=js&"
import style0 from "./PaintedRock.vue?vue&type=style&index=0&id=39ddeac3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddeac3",
  null
  
)

export default component.exports